import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Header from "./../../../component/organisms/header";
import { errorHandler } from "../../../util/errorHandler";
import { toastMsg } from "../../../util/toastMsg";
import { toast } from "react-toastify";
import MainLayout from "./../../../component/atoms/layout/mainLayout";
import Sidebar from "./../../../component/organisms/sidebar";
import TableLayout from "./../../../component/atoms/layout/table/tableLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import TableSearchBtn from "./../../../component/atoms/layout/table/tableSearchBtn";
import SearchBar from "./../../../component/atoms/input/searchBar";
import { route } from "./../../../router/route";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import Td from "./../../../component/atoms/layout/table/td";
import moment from "moment";
import TableFilter from "./../../../component/atoms/layout/table/tableFilter";
import TableDelBtn from "./../../../component/atoms/button/tableDelBtn";
import DetailBtn from "./../../../component/atoms/button/detailBtn";
import Pagination from "./../../../component/molecules/pagination";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "./../../../util/modalMsg";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import { saveAs } from "file-saver";
import ExcelApi from "../../../api/excel.api";
import AddBtn from "../../../component/atoms/button/addBtn";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import DelBtn from "../../../component/atoms/button/delBtn";
import ConsultingApi from "./../../../api/consulting.api";
import { imgUrl } from "./../../../constants/url";

const ConsultingProduct = () => {
  // --------------------------------- //
  // ---------- 더미 데이터 ---------- //
  // ------------------------------- //

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  // ----------------------------------- //
  // ---------- 마운트가 되면 ---------- //
  // --------------------------------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getProductList();
  }, [location]);

  const [consultingList, setConsultingList] = useState([]);
  const [keyword, setKeyword] = useState("");

  const getProductList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
      };
      let responseData = (await ConsultingApi.get(data)).data.data;

      setConsultingList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const [pagination, setPagination] = useState({
    size: 5, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 1,
    totalPages: 1,
  });

  const isAllCheck = useMemo(() => {
    const checkedList = consultingList.filter((item) => item.checked);
    return (
      checkedList.length !== 0 && checkedList.length === consultingList.length
    );
  }, [consultingList]);

  const [title, setTitle] = useState("컨설팅 관리");
  const [subTitle, setSubTitle] = useState("항목");

  // ----- 활성/비활성
  const [filterOpen, setFilterOpen] = useState(-1);
  const [activationId, setActivationId] = useState(null);
  const [activation, setActivation] = useState(null);
  const [activationModalTitle, setActivationModalTitle] = useState("");
  const [activationModalOpen, setActivationModalOpen] = useState(false);

  const activationFunc = async () => {
    try {
      const data = {
        activation: activation,
      };
      await ConsultingApi.activation(activationId, data);
      toast(toastMsg.create);
      setFilterOpen(-1);
      setActivationModalOpen(false);
      getProductList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: delIdList,
      };
      await ConsultingApi.delete(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      setDelIdList([]);
      getProductList();
    } catch (error) {
      errorHandler(error);
    }
  };

  //------------엑셀 생성
  const downloadExcel = async (excelData) => {
    const Excel = require("exceljs");
    const workbook = new Excel.Workbook();
    workbook.addWorksheet("Sheet One");
    const sheetOne = workbook.getWorksheet("Sheet One");

    sheetOne.columns = [
      { header: "컨설팅명", key: "title", width: 40 },
      { header: "수강 인원", key: "studentCount", width: 40 },
      { header: "총 매출액", key: "totalSalePrice", width: 40 },
      { header: "활성 상태", key: "activation", width: 40 },
    ];

    excelData.map((item) => {
      // 행 추가
      sheetOne.addRow(item);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "컨설팅 관리.xlsx");
  };

  const getExcelAll = async () => {
    try {
      const excelArr = [];
      const response = (
        await ExcelApi.GetConsultingExcel({
          ids: [],
          allFlag: true,
        })
      ).data.data.content;

      response.map((item) => {
        const activeTitle = item.activation ? "활성" : "비활성";
        const totalSalePrice = item.totalSalePrice?.toLocaleString();
        excelArr.unshift({
          ...item,
          activation: activeTitle,
          totalSalePrice: totalSalePrice,
        });
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getExcelChecked = async () => {
    const filter = consultingList.filter((item) => item.checked);
    if (filter.length <= 0) {
      return toast("항목을 선택해주세요");
    }

    try {
      const excelArr = [];
      const response = (
        await ExcelApi.GetConsultingExcel({
          ids: filter.map((item) => item.id),
          allFlag: false,
        })
      ).data.data.content;

      response.map((item) => {
        const activeTitle = item.activation ? "활성" : "비활성";
        const totalSalePrice = item.totalSalePrice?.toLocaleString();
        excelArr.unshift({
          ...item,
          activation: activeTitle,
          totalSalePrice: totalSalePrice,
        });
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };
  //------------액셀 부분 끝

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>{title}</TableTitle>
          <TableTop>
            <TableCount text={subTitle} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(
                      `${route.consulting_product}?page=1&keyword=${encodeURIComponent(
                        keyword
                      )}`,
                      {
                        replace: true,
                      }
                    );
                    setTitle("검색 결과");
                    setSubTitle("검색 결과");
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.consulting_product}?page=1&keyword=${encodeURIComponent(
                      keyword
                    )}`,
                    {
                      replace: true,
                    }
                  );
                  setTitle("검색 결과");
                  setSubTitle("검색 결과");
                }}
              />
              <ExcelBtn
                onSelectClick={getExcelChecked}
                onAllClick={getExcelAll}
              />
              <DelBtn
                text={"컨설팅 추가"}
                onClick={() => navigate(route.consulting_add)}
              />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              {/* 체크박스 영역 */}
              <col width="90px" />
              {/* 컨설팅명 */}
              <col width="551px" />
              {/* 수강 인원 */}
              <col width="87px" />
              {/* 총 매출액 */}
              <col width="101px" />
              {/* 활성 상태 */}
              <col width="113px" />
              {/* 삭제하기 */}
              <col width="95px" />
              {/* 상세보기 */}
              <col width="73px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setConsultingList(
                          consultingList.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setConsultingList(
                          consultingList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText>컨설팅명</TableText>
                </Th>
                <Th>
                  <TableText>수강 인원</TableText>
                </Th>
                <Th>
                  <TableText>총 매출액</TableText>
                </Th>
                <Th>
                  <TableText>활성 상태</TableText>
                </Th>
                <Th>
                  <TableText>삭제하기</TableText>
                </Th>
                <Th>
                  <TableText>상세보기</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {consultingList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{ height: "124px", background: "#fff" }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setConsultingList([...consultingList]);
                        }}
                      />
                    </Td>
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "23px",
                        }}
                      >
                        <img
                          style={{
                            width: "150px",
                            height: "94px",
                            borderRadius: "3px",
                          }}
                          src={imgUrl + item.thumbnailServerFileName}
                        />
                        <TitleText
                          style={{
                            width: "300px",
                          }}
                        >
                          {item.title}
                        </TitleText>
                      </div>
                    </Td>
                    <Td>
                      <TableText>{item.studentCount}명</TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {item.totalSalePrice.toLocaleString()}원
                      </TableText>
                    </Td>
                    <Td>
                      <TableFilter
                        style={{
                          width: "75px",
                        }}
                        onClick={() => {
                          filterOpen === index
                            ? setFilterOpen(-1)
                            : setFilterOpen(index);
                        }}
                        isOpen={filterOpen === index}
                        selectedValue={item.activation}
                        list={[
                          {
                            value: true,
                            title: "활성",
                            onClick: () => {
                              setActivationId(item.id);
                              setActivation(true);
                              setActivationModalTitle("활성화");
                              setActivationModalOpen(true);
                            },
                          },
                          {
                            value: false,
                            title: "비활성",
                            onClick: () => {
                              setActivationId(item.id);
                              setActivation(false);
                              setActivationModalTitle("비활성화");
                              setActivationModalOpen(true);
                            },
                          },
                        ]}
                      />
                    </Td>
                    <Td>
                      <TableDelBtn
                        style={{ marginLeft: "6px" }}
                        onClick={() => {
                          setConsultingList([...consultingList]);
                          const delList = [item];
                          setDelIdList(delList.map((item) => item.id));
                          setDeleteModalOpen(true);
                        }}
                      />
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(
                            route.consulting_detail_info + `/${item.id}`
                          );
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.consulting_product}
            queryString={`keyword=${encodeURIComponent(
              searchParams.get("keyword") || ""
            )}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>

      {activationModalOpen ? (
        <Modal
          title={`${activationModalTitle} 하시겠습니까?`}
          setModalOpen={setActivationModalOpen}
          onClick={() => {
            activationFunc();
          }}
        />
      ) : null}

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default ConsultingProduct;

const TitleText = styled(PretendardText)`
  width: 330px;
  color: #778088;
  font-size: 14px;
  font-weight: 500;
  line-height: 22.75px;

  overflow: hidden; /* 텍스트 넘침 방지 */
  display: -webkit-box; /* 플렉스 박스 유사 동작 */
  -webkit-line-clamp: 2; /* 두 줄까지만 표시 */
  -webkit-box-orient: vertical; /* 텍스트 수직 정렬 */
  text-overflow: ellipsis; /* 넘치는 텍스트에 말줄임표 추가 */
  word-break: break-word; /* 긴 단어도 적절히 줄바꿈 */
`;
